// libs
import React, { memo, useRef } from "react";

// contexts
import MobileActionContext from "./Context";

// defs
type IMobileActionProvider = React.PropsWithChildren<{}>;

const EMPTY_FUNC = () => {
    /** DO NOTHING */
};

function MobileActionProvider({ children }: IMobileActionProvider) {
    const showSearchCallback = useRef(EMPTY_FUNC);

    const setShowSearchCallback = (cb: VoidFunction) => {
        showSearchCallback.current = cb;
    };

    const showSearch = () => showSearchCallback.current();

    return (
        <MobileActionContext.Provider value={{ showSearch, setShowSearchCallback }}>
            {children}
        </MobileActionContext.Provider>
    );
}

export default memo(MobileActionProvider);
